import { ElementRef } from '@angular/core'
import { FncBaseCompnent } from './fncbase.component'
import { FormDirective } from './html-directives/form.directive'

export abstract class FncFormChildComponent extends FncBaseCompnent {
  constructor(element: ElementRef, public parentForm: FormDirective) {
    super(element)
  }
}
